import React, { useState } from 'react';import { FaUsers, FaStar } from "react-icons/fa";
import { BsGraphUp } from "react-icons/bs";

function CustomCopyTrade() {
  return (
    <div
      className="card p-3 shadow-lg rounded-4 text-light"
      style={{ background: "linear-gradient(145deg, #1a1c1f, #111315)" }}
    >
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex align-items-center">
          {/* Custom Avatar */}
          <img
            src="https://i.pravatar.cc/40?img=12"
            alt="Trader"
            className="rounded-circle me-2 border border-secondary"
          />
          <div>
            <h5 className="mb-0 fw-bold">Gunbot</h5>
            <small className="text-secondary d-flex align-items-center">
              <FaUsers className="me-1 text-info" /> 100/500
              <span className="badge bg-secondary ms-2">API</span>
            </small>
          </div>
        </div>
        <FaStar className="text-warning fs-4" />
      </div>

      {/* Profit + Chart */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <p className="mb-0 text-secondary">Profit Share</p>
          <h3 className="text-success fw-bold">50%</h3>
          <small className="text-success">Win Rate 50%</small>
        </div>
        <div>
          <BsGraphUp className="text-success fs-1" />
        </div>
      </div>

      {/* Stats */}
      <div className="row text-center mb-3">
        <div className="col">
          <p className="mb-1 text-secondary small">Copy Price (USDT)</p>
          <h6 className="fw-bold">$500</h6>
        </div>
        <div className="col">
          <p className="mb-1 text-secondary small">AUM (USDT)</p>
          <h6 className="fw-bold">44,882.26</h6>
        </div>
        <div className="col">
          <p className="mb-1 text-secondary small">No. Win</p>
          <h6 className="text-success fw-bold">600</h6>
        </div>
        <div className="col">
          <p className="mb-1 text-secondary small">No. Loss</p>
          <h6 className="text-danger fw-bold">180</h6>
        </div>
      </div>

      {/* Buttons */}
      <div className="d-flex">
        <button className="btn btn-outline-info w-50 me-2 rounded-3 fw-bold">
          VIEW
        </button>
        <button className="btn btn-danger w-50 rounded-3 fw-bold">
          COPIED
        </button>
      </div>
    </div>
  );
}

export default CustomCopyTrade;
